import { transform } from './config';


/**
 * 日期格式化
 * @param {Date} date
 * format  需要转换的时间格式   default="YYYY-MM-DD hh:mm:ss"
 */
const dateFormat = function (date: Date, format = "YYYY-MM-DD hh:mm:ss") {

    if (date == undefined) return '';
    if (typeof date === 'number') {
        date = new Date(date);
    } else if (typeof date === 'string') {
        date = new Date(date);
        if (date.toString() === 'Invalid Date') {
            date = new Date(+date);
        }
    }
    if (date.toString() === 'Invalid Date') return '';
    const repo = {
        YYYY: date.getFullYear(),
        MM: transform(date.getMonth() + 1),
        DD: transform(date.getDate()),
        hh: transform(date.getHours()),
        mm: transform(date.getMinutes()),
        ss: transform(date.getSeconds())
    }
    return format.replace(/\w+/g, function (match) {
        return repo[match];
    });
}

// 面试结果
const stateType = function (value: number, obj: any) {
    for (let item of obj) {
      if (value == item.value) {
        return item.label;
      }
    }
  }

  // 录用岗位
const offerJob = function (value: number, obj: any) {
    for (let item of obj) {
      if (value == item.id) {
        return item.jobName;
      }
    }
  }
export default {
    dateFormat,
    stateType,
    offerJob
}